import React from 'react';
import {
  Box,
  Modal,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const PreviewIndicator = ({ open, close, indicator }) => {
  return (
    <Modal open={open} onClose={close}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50%",
          height: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Preview Indicador</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>
        {indicator && (
          <img
            src={indicator.imagen}
            alt={indicator.titulo}
            style={{
              width: "100%",
              maxHeight: "70%",
              objectFit: "contain",
              marginTop: "15px",
            }}
          />
        )}
      </Box>
    </Modal>
  );
};
